import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import UiButton from 'ui-components/ui-button/UiButton';
import UiDialogActions from 'ui-components/ui-dialog-actions/UiDialogActions';
import UiDialogContent from 'ui-components/ui-dialog-content/UiDialogContent';
import UiDialogTitle from 'ui-components/ui-dialog-title/UiDialogTitle';
import { StyledServiceWorkerUpdateDialog } from './ServiceWorkerUpdateModal.styles';

const ServiceWorkerUpdateModal = ({
  open = false,
  versionNumber,
  onClose,
  onReload,
}) => {
  const { t } = useTranslation();

  return (
    <StyledServiceWorkerUpdateDialog
      open={open}
      maxWidth='xs'
      fullWidth
      onClose={onClose}
      data-testid='service-worker-update-modal'
    >
      <div className='icon-container'>
        <div className='icon-outline'>
          <UiIcon
            icon='ri-information-line'
            size={16}
            color='#008BF8'
            hover='#008BF8'
          />
        </div>
      </div>

      <UiDialogTitle>
        {t('common:serviceWorkerUpdateTitle', {
          version: versionNumber,
        })}
      </UiDialogTitle>
      <UiDialogContent>
        <p className='m-0 description'>
          {t('common:serviceWorkerUpdateDescription')}
        </p>
      </UiDialogContent>
      <UiDialogActions>
        <UiButton onClick={onReload} style={{ color: 'white' }}>
          {t('common:serviceWorkerUpdateAction')}
        </UiButton>
        <UiButton variant='text' onClick={onClose}>
          {t('common:close')}
        </UiButton>
      </UiDialogActions>
    </StyledServiceWorkerUpdateDialog>
  );
};

ServiceWorkerUpdateModal.propTypes = {
  open: PropTypes.bool,
  versionNumber: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
};

export default ServiceWorkerUpdateModal;
